// extracted by mini-css-extract-plugin
module.exports = {"container":"tag-link_container__rpmUF"};